<template>
  <div
    :class="`body azour_body `"
    id="body"
    :dir="getDir()"
    :style="viewType ? azourBody : ''"
  >
    <div class="body_content" :style="viewType ? azourBodyContent : ''">
      <div
        :class="`category `"
        v-for="(section, index) in newItem[currentLang].sections"
        :key="`${index}_sections_menu`"
      >
        <span :class="`category_title collapsed_category `">
          <span :class="`text  `"
            >{{ section.title }}</span
          >
          <div>
            <span
              :class="
                `collapsed ${
                  collapsed_category.includes(section._id) ? 'rotated' : ''
                }`
              "
              @click="toggleCllapsCategory(section)"
              ><i class="fas fa-chevron-up"></i
            ></span>
          </div>
        </span>
        <template class="full" v-if="!collapsed_category.includes(section._id)">
          <div
            v-for="(subSection, indexSubCategorie) in section.sub_sections"
            :key="`${indexSubCategorie}_sub_sections_menu`"
            :class="`items_list_azour `"
          >
            <span :class="`subcategory_title collapsed_category `">
              <span :class="`text `">{{ subSection.title }}</span>
              <div>
                <span
                  :class="
                    `collapsed ${
                      collapsed_subcategory.includes(subSection._id)
                        ? 'rotated'
                        : ''
                    }`
                  "
                  @click="toggleCllapsSubCategory(subSection)"
                  ><i class="fas fa-chevron-up"></i
                ></span>
              </div>
            </span>
            <template v-if="!collapsed_subcategory.includes(subSection._id)">
              <div
                class="items"
                v-for="(item, indiceItem) in subSection.items"
                :key="`${indexSubCategorie}_${indiceItem}_mwnu_items`"
                style="position:relative;"
              >
                <div
                  class="item"
                  @click="(e)=>{addToCart(item,e)}"
                  style="position:relative;"
                >
                  <div
                    :class="
                      `success_added ${
                        selectes_ids.includes(item._id) ? 'showed' : ''
                      }`
                    "
                  >
                    Article bien ajoute avec succees<br />
                    <span class="cart"
                      ><i class="fa fa-shopping-cart" aria-hidden="true"></i
                    ></span>
                  </div>
                  <div :class="`infos  `">
                    <span class="title">{{ item.title }} </span>
                    <span class="title-custom"
                      >{{ item.title }} {{ item.price }}
                      {{ currentCurrency.symbol }}</span
                    >
                    <span class="description">{{
                      item.observation ? item.observation : ""
                    }}</span>
                    <div class="tags">
                      <img :src=" `htttp://localhost:3333/uploads/tags/${tag.image}`" alt="" class="tag" v-for="tag in item.tags" :key="`${tag._id}_${item._id}`">
                    </div>
                  </div>
                  <div>
                    <span class="price"
                      ><span>{{ item.price }}</span>
                      {{ currentCurrency.symbol }} <br />
                      <span class="addTo"><i class="fas fa-plus"></i></span>
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { apiPath1 } from "../../constants/config";
export default {
  props: [
    "viewType",
    "selectes_ids",
    "smaler",
    "newItem",
    "newSection",
    "listSections",
    "changeSectionTitle",
    "changeSectionSubTitle",
    "setCurrentTab",
    "currentTab",
    "addItem",
    "newSubSection",
    "handleChangeShowSub",
    "disponibleItem",
    "showItem",
    "changeItemObservation",
    "changeItemPrice",
    "changeItemTitle",
    "editCategorie",
    "deleteSection",
    "editSubCategorie",
    "deleteSubSection",
    "editItem",
    "deleteItem",
    "currentCurrency",
    "currentLang",
    "selectedLangues",
    "addToCart",
  ],
  data() {
    return {
      collapsed_subcategory: [],
      collapsed_category: [],
      apiPath1,
      selected: 0,
      sub_selected: 0,
    };
  },
  computed: {
    azourBody: function() {
      return { "max-width": "unset !important", width: "100%" };
    },
    azourBodyContent: function() {
      return { "max-width": "unset !important", width: "100%" };
    },
  },
  watch: {
    selected(newval) {
      // if(newVal!=this.currentTab){
      this.setCurrentTab(newval);
      // }
    },
    currentTab(newVal) {
      if (newVal != this.selected) {
        this.selected = newVal;
      }
    },
  },
  methods: {
    toggleCllapsCategory(section) {
      if (this.collapsed_category.includes(section._id)) {
        this.collapsed_category.splice(
          this.collapsed_category.indexOf(section._id)
        );
      } else {
        this.collapsed_category.push(section._id);
      }
    },
    toggleCllapsSubCategory(subsection) {
      if (this.collapsed_subcategory.includes(subsection._id)) {
        this.collapsed_subcategory.splice(
          this.collapsed_subcategory.indexOf(subsection._id)
        );
      } else {
        this.collapsed_subcategory.push(subsection._id);
      }
    },
    getDir() {
      if (this.selectedLangues[this.currentLang].key.toLowerCase() == "ar") {
        return "ltr";
      }
      return "ltr";
    },
    deleteCategorie() {
      let old_selected = this.selected;
      if (this.selected != 0) {
        this.selected = this.selected - 1;
      }
      this.deleteSection(old_selected);
    },
    showSub(subSection) {
      if (
        this.newItem[0].sections[this.selected].show_subCategories &&
        !subSection.defaultNonSub
      ) {
        return true;
      } else if (
        !this.newItem[0].sections[this.selected].show_subCategories &&
        subSection.defaultNonSub
      ) {
        return true;
      }
      return false;
    },
  },
};
</script>
<style>
.full {
  width: 100%;
}
.collapsed i {
  transition: all 0.5s;
  transform: rotate(0deg);
}
.rotated i {
  transition: all 0.5s;
  transform: rotate(180deg);
}
.success_added {
  width: 0%;
  background: black;
  color: #fff;
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  left: 6px;
  top: 0px;
  z-index: 99;
  height: 100%;
  /* display: none; */
  overflow: hidden;
  transition: width 0.001s;
  animation-fill-mode: forwards;
  padding-top: 12px;
  font-size: 12px;
}
.success_added .cart .fa {
  font-size: 12px;
}

.success_added.showed {
  display: flex;
  width: 100%;
  transition: width 0.1s;
}
.azour_body .items {
  min-height: unset !important;
}
.text.smaler {
  font-size: 10px;
}
.collapsed_category.smaler {
  margin-bottom: 6px !important;
}
.azour_body.body.smaler {
  width: 100%;
  min-height: unset;
}
.dorpdown_theme .new_sub {
  background-color: #fff;
  color: black;
  border-radius: 50px;
}
.new_sub .btn-outline-secondary {
  background-color: initial !important;
  color: initial !important;
  border: none !important;
  border-color: initial !important;
  padding: 0px !important;
}
.sub_category_options {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.azour_new_category {
  width: calc(100% - 24px);
  margin: auto;
  height: 40px;
  background: black;
  color: #fff;
  justify-content: center;
  display: flex;
  position: relative;
  top: 21px;
  margin-bottom: 24px;
  align-items: center;
  cursor: pointer;
}
.azour_new_category:hover {
  background: #fff;
  color: black;
}
.azour_new_category span {
}
.items_list_azour {
  width: 100%;
  padding: 18px;
}
.items_list_azour.smaler {
  width: 100%;
  padding: 6px;
}
.azour_body.body {
  width: calc(100% - 24px);
  background-color: #fff;
  min-height: 100vh;
  max-width: 780px;
  background-image: url(htttp://localhost:3333/azour/img/background.jpg);
  padding: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
  -webkit-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
}
.azour_body .body_content {
  background-color: #fff;
  width: 100%;
  max-width: 780px;
  background-color: #fff;
  height: 100%;
  padding-bottom: 12px;
  min-height: 100vh;
}
.azour_body span,
.azour_body div,
.azour_body p {
  font-family: "Roboto Mono", monospace;
}
.azour_body .category {
  width: 100%;
  padding-left: 24px;
  padding-right: 12px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}
.azour_body .category.smaler {
  width: 100%;
  padding-left: 12px;
  padding-top: 12px;
  display: flex;
  flex-direction: column;
}
.azour_body .category_title {
  position: relative;
  width: calc(100% - 0px);
  font-size: 18px;
  font-weight: bold;
  text-transform: uppercase;
  border-bottom: 6px solid black;
  margin-bottom: 24px;
  display: block;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
  background: black;
  color: #fff;
  padding: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.azour_body .subcategory_title {
  position: relative;
  width: calc(100% - 0px);
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 6px solid black;
  margin-bottom: 24px;
  display: block;
  padding-bottom: 12px;
  display: flex;
  justify-content: space-between;
}
.azour_body .subcategory_title * {
  text-align: left;
}

.azour_body .collapsed {
  /* position: absolute;
  right: 5px; */
}
.azour_body .items {
  width: 100%;
  right: 0px;
  padding: 0px !important;
}
.azour_body .addTo {
  /* position: absolute;
  right: 0;
  top: 20px; */
  color: black;
  float: right;
}
.azour_body .ajouter {
  position: absolute;
  display: none;
  color: #fb7f15;
  right: 140px;
  top: -1px;
  font-size: 12px;
  font-weight: 700;
}
.azour_body .item {
  display: flex;

  width: calc(100% - 52px);
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;
  border-bottom: 1px solid #8080801c;
  padding-bottom: 12px;
  /* cursor: pointer; */
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
  flex-direction: row;
  min-height: unset !important;
  overflow-y: show !important;
  /* right: 18px; */
  overflow: hidden;
}
.azour_body .infos {
  display: flex;
  flex-direction: column;
  flex: 1;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
  justify-content: center;
  align-items: flex-start;
  max-width: calc(100% - 80px);
}
.azour_body .title {
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 500;
  margin-bottom: 6px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
}
.azour_body .title-custom {
  display: none;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 800;
  margin-bottom: 6px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently*/
}
.azour_body .description {
  font-size: 10px;
  text-transform: uppercase;
  font-weight: 400;
  text-align: left;
}
.azour_body .price {
  font-size: 12px;
  margin-left: 16px;
  font-weight: bold;
}

/* #section01 { background: url(https://picsum.photos/1200/800?image=575) center center / cover no-repeat;} */

.azour_body #section01 {
  position: relative;
  color: #fff;
  text-transform: uppercase;
  /* background-color: red; */
  overflow: hidden;
}
.azour_body #section01 span {
  position: absolute;
  top: 20px;
  left: 50%;
  width: 24px;
  height: 24px;
  margin-left: -12px;
  border-left: 1px solid #fff;
  border-bottom: 1px solid #fff;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  box-sizing: border-box;
}

.azour_body .scroll-down {
  height: 50px;
  width: 30px;
  border: 2px solid #fff;
  position: absolute;
  left: 46%;
  bottom: 20px;
  border-radius: 50px;
  cursor: pointer;
  outline: unset !important;
}
.collapsed {
  cursor: pointer;
}
@media screen and (max-width:580px) {
  .azour_body .title{
    font-size: 12px;
    text-align: left;
  }
}

.tags img{
  margin-right: 6px;
}
.tag{
  
}
</style>
